module.exports = __webpack_public_path__ + "img/grand-beach-2.0df2e619.jpg";